import { reactive, computed, onBeforeMount } from '@vue/composition-api'

export const Service = (props, context) => {

  onBeforeMount(() => {
    // 審査中状態のチェック
    store.dispatch('payment/checkAvailablePurchase')
  })

  const state = reactive({
    initialize: false,
    visibleCancelInput: false,
    isUnderExam: computed(() => store.state.payment.isUnderExam), // 審査中フラグ
    boughtThisMonthDifPayment: computed(() => store.state.payment.boughtThisMonthDifPayment) // 同月異なる決済方法での購入済みフラグ
  })

  const store = context.root.$store
  const router = context.root.$router
  const { contractPack, contract } = store.state

  const promiseList = [
    store.dispatch('contract/getContractData'),
    store.dispatch('contractPack/getPackageData')
  ]

  Promise
    .all(promiseList)
    .then(() => {
      state.initialize = true
    })

  const isAgreement = computed(() => store.getters['contract/isAgreement'])

  const visibleDetailPackage = computed(() => store.getters['contractPack/visibleDetailPackage'])
  // const canTrialPackage = computed(() => store.getters['contractPack/canTrialPackage'])
  const canTrialProduct = computed(() => store.getters['contractPack/canTrialProduct'])
  const packageStatusWord = computed(() => store.getters['contractPack/packageStatusWord'])
  const packageEnd = computed(() => store.getters['contractPack/packageEnd'])
  const clickDetail = (select) => {
    store
      .dispatch('contractPack/setSelectPackage', select)
      .then(() => {
        router.push({ name: 'PCServiceDetail' })
      })
  }
  return {
    isAgreement,
    visibleDetailPackage,
    // canTrialPackage,
    canTrialProduct,
    packageStatusWord,
    packageEnd,
    clickDetail,
    state,
    contractPack,
    contract
  }
}
